export default {
  indicators: [],
  interaction: {},
  interactions: [],
  status: true,
  submittedPlugins: [],
  pluginsImported: [
    'accessibilityPlugin',
    'contextPlugin',
    'customReportBuilder',
    'indicatorPlugin',
    'reviewPlugin',
    'screenshotManager',
    'insightSummaryPlugin',
    'testonePlugin',
    'testPlugin',
  ],
  users: [],
  activeDashboards: [],
};
